import { useEffect, useState } from "react";
import layerLibrary from "../../canvas/LayerLibrary";

const useToolLayers = () => {
  const [toolLayers, setToolLayers] = useState([]);

  useEffect(() => {
    let mounted = true;

    const refreshLayers = async () => {
      try {
        await layerLibrary.ensureLoaded?.();
        const layers = layerLibrary.getAllLayers?.() || [];
        if (mounted) setToolLayers(Array.isArray(layers) ? layers : []);
      } catch (error) {
        console.error("Failed to load layers for the parameter dropdown:", error);
        if (mounted) setToolLayers([]);
      }
    };

    refreshLayers();
    window.addEventListener("layers-updated", refreshLayers);
    window.addEventListener("hierarchy-updated", refreshLayers);

    return () => {
      mounted = false;
      window.removeEventListener("layers-updated", refreshLayers);
      window.removeEventListener("hierarchy-updated", refreshLayers);
    };
  }, []);

  return toolLayers;
};

export default useToolLayers;
